import styles from './switch.module.scss';

/**
 * Generic Checkbox input but styled as a switch
 *
 * @param props - The component props
 * @param props.id - string for Select id
 * @param props.name - string for select name
 * @param props.title - string for label title
 * @param props.required - Boolean to require field on submit (optional)
 * @param props.onChange - onChange function to be passed into component for form control (optional)
 * @param props.autoComplete - string for auto-complete attribute (optional)
 * @returns JSX element representing the Switch component
 * 
 * @example
 * ```tsx
 * <Switch
 *    id="switchinput"
 *    name="switchinput"
 *    title="Switch Input"
 *    required={true}
 *    onChange={handleChange}
 * />
 */
const Switch = ({
    id,
    name,
    title,
    required = false,
    onChange,
    autoComplete='off',
    checked,
}: {
    id: string;
    name: string;
    title: string;
    required?: boolean;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    autoComplete?: string;
    checked?: boolean;
}) => {
    return (
        <div className={styles.switchcontainer}>
            <label className={styles.switch} htmlFor={id}>
                <input
                    type="checkbox"
                    onChange={onChange && onChange}
                    id={id}
                    name={name}
                    required={required}
                    autoComplete={autoComplete}
                    checked={checked}
                />
                <span className={styles.slider} />
            </label>
            {title}
        </div>
    );
};

export default Switch;
